<div class="toolbox-pages-grid">
  <h2 class="mat-display-2">Toolbox</h2>
  <div class="tools" fxFlexAlign="stretch">
    <mat-card routerLink="/methodenkoffer">
      <mat-card-header>
        <mat-card-title>Methodenkoffer für Dozenten</mat-card-title>
      </mat-card-header>
      <img mat-card-image src="assets/images/Methodenkoffer.jpg" alt="Methodenkoffer">
    </mat-card>
    <mat-card routerLink="/toolbox">
      <mat-card-header>
        <mat-card-title>Übersetzungstool</mat-card-title>
      </mat-card-header>
      <img mat-card-image src="assets/images/Überstzungstool.png" alt="Überstzungstool">
    </mat-card>
  </div>
</div> 